import { render, staticRenderFns } from "./CallCenter.vue?vue&type=template&id=42af1d90&"
import script from "./CallCenter.vue?vue&type=script&lang=ts&"
export * from "./CallCenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports